import { api } from './client';

/*  Il biglietto: tre chiamate, tutte senza essere collegati.

    Sono le uniche dell'applicativo che si fanno da anonimi, e il motivo e' ovvio — chi le
    usa non e' entrato, ed e' il problema che sta cercando di risolvere.

    Nessuna delle tre dice mai se un indirizzo o un'utenza esistono. Il «password
    dimenticata» risponde la stessa frase sempre, e il biglietto non valido non distingue
    fra scaduto, gia' usato e inventato: dire quale dei tre aiuterebbe solo chi prova
    biglietti a caso.
*/

/// Chi c'è dietro a un biglietto valido, per salutare per nome invece che chiedere una password a un anonimo.
export interface SchedaBiglietto {
  nomeCompleto: string;
  codice: string;
  /** Prima password, non un reimposta: le parole della schermata cambiano. */
  primoAccesso: boolean;
}

/// Esito del tentativo di mandare un invito, come lo legge la scheda dell'utenza.
export interface EsitoInvito {
  accodato: boolean;
  /** Perché non è partito: manca l'indirizzo, la posta non è configurata. Null quando è partito. */
  perche: string | null;
}

export const inviti = {
  /*  Risponde sempre bene, indirizzo conosciuto o no. Il messaggio che torna e' quello da
      mostrare: scriverne uno qui vorrebbe dire averne due da tenere allineati.  */
  passwordDimenticata: (indirizzo: string) =>
    api.post<{ messaggio: string }>('/sessione/password-dimenticata', { indirizzo }),

  leggi: (biglietto: string) =>
    api.get<SchedaBiglietto>(`/sessione/invito?t=${encodeURIComponent(biglietto)}`),

  imposta: (biglietto: string, password: string) =>
    api.post<{ messaggio: string }>('/sessione/invito', { biglietto, password }),
};
